// 'use strict';

import * as FileSaver from "file-saver";
import {Subscription} from "rxjs";
// import {CustomStudies} from "../components/chartiq/models/CustomStudies";
import {AppUtil} from "../js/util/AppUtil";
import {formatDate} from "../js/util/DateTimeUtil";
import {Optional} from "../js/util/Optional";

angular.module("myApp.chart.chart-directive", [])

       .directive("tfStxChart", function () {
           return {
               restrict: "E",
               templateUrl: "app/chart/chart-directive.tpl.html",
               scope: {
                   chartSymbol: "=",
                   layoutid: "=",
                   linker: "=",
                   onCreate: "&",
                   onDestroy: "&"
               },
               controller
           };
       });

/** @ngInject */
function controller($scope, $http, $window, $timeout, quoteFeedService, $location, $localStorage,
                    currentUserService) {

    /* TODO Legacy Keys for extracting the old LocalStorage save locations, should be removed eventually */
    const symbolStorageKey = `tfChartSymbol${$scope.layoutid}`;
    const layoutStorageKey = `tfStrategyChartLayout${$scope.layoutid}`;
    const drawingStorageBaseKey = `tfChartDrawings${$scope.layoutid}`;
    const comparisonsStorageBaseKey = `tfChartComparisons${$scope.layoutid}`;
    const hudStateStorageKey = `tfChartHudState${$scope.layoutid}`;

    const symbolPreferenceKey = "symbol";
    const layoutPreferenceKey = "layout";
    const drawingPreferenceKey = "drawings";
    const comparisonPreferenceKey = "comparisons";
    const hudPreferenceKey = "hud";

    let preferences = {};

    const loadLayoutPrefs = () => {
        const chartingPrefs = currentUserService.chartingPreference() || {};
        preferences = chartingPrefs[$scope.layoutid] || {};
    };

    loadLayoutPrefs();

    // Debounced because the changes happen a few times per chart update in places
    const updatePreferences = AppUtil.debounce(async () => {
        const chartingPreferences = currentUserService.chartingPreference() || {};
        preferences.symbol = $scope.symbol;
        chartingPreferences[$scope.layoutid] = preferences;
        await currentUserService.updateChartPreference(chartingPreferences);
        loadLayoutPrefs();
    }, 250);

    const preferencesChanged = async () => {
        updatePreferences();
    };

    let chartApi = null;
    // These need to be done individually as we have to recreate them when the symbol changes
    let layoutSub = Subscription.EMPTY;
    let drawingSub = Subscription.EMPTY;
    let seriesSub = Subscription.EMPTY;
    let hudSub = Subscription.EMPTY;

    $scope.quoteFeed = quoteFeedService;
    $scope.symbol = $scope.chartSymbol || $location.search().symbol;

    const symbolWatch = $scope.$watch("chartSymbol", (newVal) => {
        if (newVal != null) {
            $scope.companyChanged(newVal);
        }
    });
    $scope.$on("$destroy", symbolWatch);

    // If no symbol provided, or this isn't the first chart in the list, try retrieve the
    // previous symbol
    if ($scope.symbol == null || $scope.layoutid > 0) {
        let storedSymbol = Optional.of(preferences[symbolPreferenceKey])
                                   .orElseGet(() => $localStorage[symbolStorageKey]);
        delete $localStorage[symbolStorageKey];
        if (storedSymbol != null) {
            $scope.symbol = storedSymbol;
        }
    }

    $scope.companyChanged = (code) => {
        unsubscribeListeners();
        preferences[symbolPreferenceKey] = code;
        preferencesChanged();
        $timeout(() => $scope.symbol = code);
    };

    $scope.chartInitialized = (api) => {
        chartApi = api;
        api.removeAllStudies();
        restoreLayout();
        restoreDrawings($scope.symbol);
        restoreComparisons($scope.symbol);
        restoreHudState();
        layoutSub = api.layoutChanges.subscribe(saveLayout);
        drawingSub = api.drawingChanges.subscribe(saveDrawings);
        seriesSub = api.seriesChanges.subscribe(saveComparisons);
        hudSub = api.hudChanges.subscribe(saveHudState);
        if ($scope.linker != null) {
            api.addPlugin($scope.linker)
        }
        $scope.onCreate({api})
    };

    const unsubscribeListeners = () => {
        layoutSub.unsubscribe();
        drawingSub.unsubscribe();
        seriesSub.unsubscribe();
        hudSub.unsubscribe();
    };

    const restoreLayout = () => {
        const layout = Optional.of(preferences[layoutPreferenceKey])
                               .orElseGet(() => $localStorage[layoutStorageKey]);
        delete $localStorage[layoutStorageKey];
        if (layout == null) {
            defaultChartLayout();
        } else {
            if ($scope.symbol != null) {
                delete layout["symbols"]
            }
            chartApi.importLayout(layout);
        }
    };

    const defaultChartLayout = () => {
        // chartApi.addStudy(CustomStudies.IMPLIED_VOLATILITY)
    };

    const saveLayout = () => {
        preferences[layoutPreferenceKey] = chartApi.exportLayout();
        preferencesChanged();
    };

    const restoreDrawings = (symbol) => {
        chartApi.clearDrawings();
        const storageKey = `${drawingStorageBaseKey}${symbol}`;
        const drawings = Optional.of(preferences[drawingPreferenceKey])
                                 .map((drawings) => drawings[symbol])
                                 .orElseGet(() => $localStorage[storageKey]);
        delete $localStorage[storageKey];
        if (drawings != null) {
            chartApi.importDrawings(drawings);
        }
    };

    const saveDrawings = () => {
        const drawingBase = preferences[drawingPreferenceKey] || {};
        drawingBase[$scope.symbol] = chartApi.exportDrawings();
        preferences[drawingPreferenceKey] = drawingBase;
        preferencesChanged();
    };

    $scope.capture = async () => {
        const blob = await chartApi.capture();
        const date = formatDate(Date.now(), "YYYYMMDDHHmmss");
        const filename = `${$scope.symbol}-${date}.png`;
        FileSaver.saveAs(blob, filename);
    };

    $scope.compare = async () => {
        const current = chartApi.currentSeries();
        // const comparisons = await iqStockComparisonService.open(current);
        // chartApi.replaceSeries(comparisons);
    };

    const saveComparisons = (series) => {
        const comparisons = preferences[comparisonPreferenceKey] || {};
        comparisons[$scope.symbol] = series;
        preferences[comparisonPreferenceKey] = comparisons;
        preferencesChanged();
    };

    const restoreComparisons = (symbol) => {
        const storageKey = `${comparisonsStorageBaseKey}${symbol}`;
        const comparisons = Optional.of(preferences[comparisonPreferenceKey])
                                    .map((comparisons) => comparisons[symbol])
                                    .orElseGet(() => $localStorage[storageKey]);
        delete $localStorage[storageKey];
        if (comparisons != null) {
            chartApi.replaceSeries(comparisons);
        }
    };

    const restoreHudState = () => {
        const visible = Optional.of(preferences[hudPreferenceKey])
                                .orElseGet(() => $localStorage[hudStateStorageKey]);
        delete $localStorage[hudStateStorageKey];
        if (visible != null) {
            chartApi.hudVisible(visible);
        }
    };

    const saveHudState = (state) => {
        preferences[hudPreferenceKey] = state;
        preferencesChanged();
    };

    $scope.toggleHud = () => {
        chartApi.toggleHud();
    };

    $scope.$on("$destroy", () => {
        unsubscribeListeners();
        if ($scope.linker != null && chartApi != null) {
            chartApi.removePlugin($scope.linker)
        }
    });
}
